module.exports = __webpack_public_path__ + "img/img11.0c5971a7.png";